import CreateColumn from '../../../../Services/agGrid/createColumn';
import { Box } from '@mui/material';
import { Button } from '../../../../Components/MUIs';

/**
 * SafBasic02(안전작업허가서) 컬럼 정의
 * 필드명: camelCase (userNm, createDate, constructionNm, status 등)
 * 서버 응답이 PascalCase일 경우 valueGetter로 변환하여 사용
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 60, false, false, false, 'checkbox', {
      maxWidth: 60,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
    }),
    {
      headerName: '신청인 정보',
      editable: true,
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'userNm',
          '성명',
          'left',
          130,
          false,
          false,
          false,
          'text',
          {
            width: 130,
            valueGetter: (params) => params.data?.userNm || params.data?.USER_NM || '',
          }
        ),
        CreateColumn(
          'createDate',
          '신청일자',
          'center',
          115,
          false,
          false,
          false,
          'text',
          {
            width: 115,
            valueGetter: (params) => params.data?.createDate || params.data?.CREATE_DATE || '',
            valueFormatter: (params) => {
              if (!params.value) return '';
              const date = new Date(params.value);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            },
          }
        ),
      ],
    },
    {
      headerName: '공사업체정보',
      editable: true,
      headerClass: 'ag-center-header',
      children: [
        CreateColumn(
          'constructionNm',
          '공사업체명',
          'left',
          190,
          false,
          false,
          false,
          'text',
          {
            width: 190,
            valueGetter: (params) => params.data?.constructionNm || params.data?.CONSTRUCTION_NM || '',
          }
        ),
        CreateColumn('status', '처리상태', 'center', 110, false, false, false, 'text', {
          width: 110,
          valueGetter: (params) => params.data?.status || params.data?.STATUS || '',
          cellStyle: (params) => {
            let color = 'black';
            let backgroundColor = 'transparent';

            switch (params.value) {
              case '반려':
                color = 'white';
                backgroundColor = '#e74c3c';
                break;
              case '승인':
                color = 'white';
                backgroundColor = '#3498db';
                break;
              case '대기':
                color = 'black';
                backgroundColor = '#f1c40f';
                break;
              default:
                color = 'black';
                backgroundColor = 'transparent';
            }

            return {
              color,
              backgroundColor,
              fontWeight: 'bold',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            };
          },
        }),
      ],
    },
    {
      headerName: '결재 처리',
      headerClass: 'ag-center-header',
      width: 280,
      pinned: 'right',
      editable: false,
      cellRenderer: (e) => {
        const status = e.data?.status || e.data?.STATUS || '';
        const pmCd = e.data?.pmCd || e.data?.PM_CD || '';
        const isDisabled = status !== '대기';

        return (
          <Box display="flex" justifyContent="space-around" width="100%">
            <Button
              size="small"
              name="반려"
              disabled={isDisabled}
              onClick={() => props.PopupClickEvent1(e)}
            />
            <Button
              size="small"
              name="승인"
              disabled={isDisabled}
              onClick={() => props.PopupClickEvent2(e)}
            />
            <Button
              size="small"
              name="반려이력"
              onClick={() => props.PopupClickEvent3(pmCd)}
            />
          </Box>
        );
      },
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    // 숨김 필드
    CreateColumn('pmCd', '작업허가서코드', 'left', 100, false, false, true, 'text', {
      hide: true,
      valueGetter: (params) => params.data?.pmCd || params.data?.PM_CD || '',
    }),
    CreateColumn('userId', '사용자ID', 'left', 100, false, false, true, 'text', {
      hide: true,
      valueGetter: (params) => params.data?.userId || params.data?.USER_ID || '',
    }),
    CreateColumn('custCd', '사업장코드', 'left', 100, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn('mapBlob', '블롭', 'left', 100, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn('mapFile', '파일', 'left', 100, false, false, true, 'text', {
      hide: true,
    }),
    CreateColumn(
      'mapFileName',
      '파일명(사용자가 올린 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
      }
    ),
    CreateColumn(
      'saveName',
      '파일명(저장되는 이름)',
      'left',
      100,
      false,
      false,
      true,
      'text',
      {
        hide: true,
      }
    ),
  ];
};

// 반려이력 그리드 컬럼 정의
export const getColumnDefs2 = () => {
  return [
    CreateColumn('returnNm', '반려자', 'left', 150, false, false, false, 'text', {
      width: 150,
      valueGetter: (params) => params.data?.returnNm || params.data?.RETURN_NM || '',
    }),
    CreateColumn(
      'returnDate',
      '반려일시',
      'left',
      130,
      false,
      false,
      false,
      'text',
      {
        width: 130,
        valueGetter: (params) => params.data?.returnDate || params.data?.RETURN_DATE || '',
        valueFormatter: (params) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 형식
        },
      }
    ),
    CreateColumn('returnDetail', '반려내용', 'left', 200, false, false, false, 'text', {
      flex: 1,
      valueGetter: (params) => params.data?.returnDetail || params.data?.RETURN_DETAIL || '',
    }),
  ];
};

export default getColumnDefs1;
